module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/22.30ae19b2.jpg";